import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class DecoTargets {
    constructor() {
        this.init();
    }

    init() {
        this.scrollStop();
        this.scrollContent();
        this.randomTargetActive();
    }

    scrollStop() {
        const container = document.querySelector('.js-contents');
        let isScrolling;
        const stoptime = 200;

        container.addEventListener('scroll', () => {
            clearTimeout(isScrolling);

            if (document.body.classList.contains('-scrollStop')) {
                document.body.classList.remove('-scrollStop');
            }

            isScrolling = setTimeout(() => {
                document.body.classList.add('-scrollStop');
            }, stoptime);
        });
    }

    scrollContent() {
        const container = document.querySelector('.js-contents');

        window.addEventListener('load', () => {
            container.addEventListener('scroll', () => {
                var scroll_y = container.scrollTop;

                if (scroll_y === 0) {
                    if (document.body.classList.contains('-showTarget')) {
                        document.body.classList.remove('-showTarget');
                    }
                } else {
                    document.body.classList.add('-showTarget');
                }
            });
        });
    }

    randomTargetActive() {
        const display_time_min = 9000;
        const display_time_max = 10000;

        const random_position_value_max_number = 4;
        
        setTimeout(() => {
            function addClassPeriodically() {
                function getRandomInterval() {
                    return Math.floor(Math.random() * display_time_min) + display_time_max;
                }

                function getRandomIntervalPosition() {
                    return Math.floor(Math.random() * random_position_value_max_number) + 1;
                }

                function addClass() {
                    //document.body.classList.add('-showasshi');
                    document.body.setAttribute('data-targetposi', getRandomIntervalPosition());

                    // 次のランダムな間隔でクラスを付加する
                    setTimeout(() => {
                        //document.body.classList.remove('-showasshi');
                        document.body.setAttribute('data-targetposi', '');
                        addClass(); // 再度クラス付加を繰り返す
                    }, getRandomInterval());
                }

                // 初回のクラス付加を開始
                setTimeout(addClass, getRandomInterval());
            }

            addClassPeriodically();
        }, 5000);
    }
}
